import MaterialUiGrid, {
  GridProps as MuiGridProps
} from "@material-ui/core/Grid";
import * as React from "react";

export const Grid: React.FC<MuiGridProps> = props => (
  <MaterialUiGrid {...props} />
);
